export default __webpack_public_path__ + "static/info_exp-e0a540b1ae93a8552fc5d900e3efaa2c.svg";